export class CookieService {
  /**
   * @param name Cookie name
   * @returns any
   */
  static get(name: string): string {
    name = encodeURIComponent(name);

    const regExp: RegExp = this.getCookieRegExp(name);

    if (!regExp) {
      return '';
    }

    const result: RegExpExecArray | null = regExp.exec(document.cookie);

    if (!result) {
      return '';
    }

    return Array.isArray(result) && result.length > 1 ? decodeURIComponent(result[1]) : '';
  }

  /**
   * @param name Cookie name
   * @param value Cookie value
   * @param expires Number of days until the cookies expires or an actual `Date`
   * @param path Cookie path
   * @param domain Cookie domain
   * @param secure Secure flag
   */
  static set(
    name: string,
    value: string,
    expires?: number | Date,
    path?: string,
    domain?: string,
    secure?: boolean,
  ) {
    let cookieString: string =
      encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';

    if (expires) {
      if (typeof expires === 'number') {
        const dateExpires: Date = new Date(
          new Date().getTime() + expires * 1000 * 60 * 60 * 24,
        );
        cookieString += 'expires=' + dateExpires.toUTCString() + ';';
      } else {
        cookieString += 'expires=' + expires.toUTCString() + ';';
      }
    }

    if (path) {
      cookieString += 'path=' + path + ';';
    }

    if (domain) {
      cookieString += 'domain=' + domain + ';';
    }

    if (secure) {
      cookieString += 'secure;';
    }

    document.cookie = cookieString;
  }

  /**
   * @param name Cookie name
   * @param path Cookie path
   * @param domain Cookie domain
   */
  static delete(name: string, path?: string, domain?: string): void {
    this.set(name, '', -1, path, domain);
  }

  /**
   * @param name Cookie name
   * @returns RegExp
   */
  static getCookieRegExp(name: string) {
    const escapedName: string = name.replace(
      /([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/gi,
      '\\$1',
    );

    return new RegExp(
      '(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)',
      'g',
    );
  }
}
